/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { AxiosError, AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TWeeklyReportAllListGetReq,
  TWeeklyReportBusyoListGetReq,
  TWeeklyReportAllListGetRes,
  TWeeklyReportBusyoYosanGetRes,
  TWeeklyReportNinusiUriageListGetRes,
  TWeeklyReportBusyoListPutReq,
  TWeeklyReportPrintReq,
} from "./TKadaiKentoKaigi"

/**
 * 業績会議に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class KadaiKentoKaigiService extends ConnectApi {
  /**
   * 全体取得
   *
   * @param {TWeeklyReportAllListGetReq} params
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TWeeklyReportAllListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TWeeklyReportAllListGetRes[]>> =
        await this.getInner(
          `/budget/kadaikentokaigi/syuzigyosekihokoku`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  get = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TWeeklyReportAllListGetRes>> =
        await this.getInner(`/budget/kadaikentokaigi/syuzigyosekihokoku/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 月予算取得
   *
   * @param {TWeeklyReportBusyoListGetReq} params
   * @param {(param: TApiResponse<TeeklyReportBusyoMikomiGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getYosan = async (params: TWeeklyReportBusyoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TWeeklyReportBusyoYosanGetRes>> =
        await this.getInner(
          `/budget/kadaikentokaigi/syuzigyosekihokoku/actions/getyosan`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 部署別取得
   *
   * @param {TWeeklyReportBusyoListGetReq} params
   * @param {(param: TApiResponse< TWeeklyReportNinusiUriageListGetRes[]>) => any} resolve
   * @memberof MenuService
   */
  getNinusiUriageList = async (params: TWeeklyReportBusyoListGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TWeeklyReportNinusiUriageListGetRes[]>
      > = await this.getInner(`/budget/kadaikentokaigi/ninusiuriage`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 週報（部署） 更新
   *
   * @param {TWeeklyReportBusyoListPutReq} data
   * @param {(param: TApiResponse<TSyaryoSyozokuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyaryoSyozokuListGetRes[]>>) => any} reject
   * @memberof SyaryoService
   */
  putWeeklyBusyo = async (data: TWeeklyReportBusyoListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `budget/kadaikentokaigi/syuzigyosekihokoku/actions/updatetext`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 週報全体帳票印刷
   *
   * @param {TWeeklyReportPrintReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printWeeklyReportAll = async (
    params: TWeeklyReportPrintReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100202`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 週報部所別帳票印刷
   *
   * @param {TWeeklyReportPrintReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printWeeklyReportBusyo = async (
    params: TWeeklyReportPrintReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100203`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 荷主売上一覧帳票印刷
   *
   * @param {TWeeklyReportPrintReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printWeeklyReportNinusi = async (
    params: TWeeklyReportPrintReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100204`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
